import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '@services/user.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { CustomerService } from '@modules/customer/customer.service';

export const userGuard: CanActivateFn = (): ReturnType<CanActivateFn> => {
    const userService = inject(UserService);
    const customerService = inject(CustomerService);
    const router = inject(Router);

    const toSignIn = () => {
        userService.authService.removeSession(); // cleanup, aber KEINE navigation
        return router.createUrlTree(['/auth', 'sign-in']);
    };

    return userService.userMe().pipe(
        switchMap((user) => {
            if (!user || !user.companyId) return of(toSignIn());
            return customerService.getCustomerById(user.companyId).pipe(
                map((customer) => (customer?._id ? true : toSignIn())),
                catchError(() => of(toSignIn()))
            );
        }),
        catchError(() => of(toSignIn()))
    );
};
